export default __webpack_public_path__ + "static/media/11849497-2A92-47A3-A714-82D52350238A_1_105_c.e2ec91f7.jpeg";